import { DownloadOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BasicProPageWithHeader from '../../../../layouts/BasicProLayout/BasicProPageWithHeader';
import { useThemeComponents } from '../../../../themes';
import { useCustomerDownloadModal } from '../../../admin/CustomerListPage/DownloadModal';
import CustomerListCI, { type CustomerListCIProps } from './CustomerListCI';

const CustomerListPage = ({ endpoint }: CustomerListCIProps) => {
    const { t } = useTranslation('applicationList');
    const [moduleListByApplication, setModuleListByApplication] = useState<string[]>([]);

    const { Button } = useThemeComponents();

    const customerDownloadModal = useCustomerDownloadModal(moduleListByApplication);
    const extra = (
        <Button icon={<DownloadOutlined />} onClick={customerDownloadModal.open} type="primary">
            {t('applicationList:actions.download')}
        </Button>
    );

    return (
        <BasicProPageWithHeader
            extra={extra}
            style={{ height: '100%', backgroundColor: '#fff' }}
            title={endpoint.title}
        >
            <CustomerListCI endpoint={endpoint} setModuleListByApplication={setModuleListByApplication} />
            {customerDownloadModal.render({ forAdmin: false })}
        </BasicProPageWithHeader>
    );
};

export default CustomerListPage;
